import axios from 'axios'
import store from '@/store'
import { getAuthorizationToken } from "@/services/utils";

axios.defaults.baseURL = process.env.VUE_APP_SERVER_URL

export default () => {
	return axios.create({
		baseURL: axios.defaults.baseURL,
		withCredentials: false,
		headers: {
			"Accept": "application/json",
			"Content-Type": "application/json",
			"Authorization": store.state.currentUser && store.state.currentUser.token
		}
	})
}